import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './locales/de.json';
import en from './locales/en.json';

export const defaultNS = 'translation';
export const resources = {
  de: { translation: de },
  en: { translation: en },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  defaultNS,
  fallbackLng: 'de',
  supportedLngs: ['de', 'en'],
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
});

export { default } from 'i18next';
